/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/time';
import '../common/currency';
import './model';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

const jsonData = {
  "squareup": {
    "nested": {
      "bizbank": {
        "nested": {
          "transaction_dispute": {
            "nested": {
              "TransactionDispute": {
                "fields": {
                  "id": {
                    "type": "int64",
                    "id": 1,
                    "rule": "optional"
                  },
                  "unitToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "status": {
                    "type": ".squareup.bizbank.transaction_dispute.DisputeStatus",
                    "id": 3,
                    "rule": "optional"
                  },
                  "statusLastUpdatedDate": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 4,
                    "rule": "optional"
                  },
                  "transactionToken": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "marqetaCaseToken": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "disputeAmount": {
                    "type": ".squareup.common.Money",
                    "id": 7,
                    "rule": "optional"
                  },
                  "transactionDate": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 8,
                    "rule": "optional"
                  },
                  "disputeForm": {
                    "type": ".squareup.bizbank.transaction_dispute.DisputeForm",
                    "id": 9,
                    "rule": "optional"
                  },
                  "sellerDisputedDate": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 10,
                    "rule": "optional"
                  },
                  "squareDisputedDate": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 11,
                    "rule": "optional"
                  },
                  "outreachUrl": {
                    "type": "string",
                    "id": 12,
                    "rule": "optional"
                  },
                  "reasonCode": {
                    "type": ".squareup.bizbank.transaction_dispute.ReasonCode",
                    "id": 13,
                    "rule": "optional"
                  },
                  "provisionalCreditAmount": {
                    "type": ".squareup.common.Money",
                    "id": 14,
                    "rule": "optional"
                  },
                  "provisionalCreditIssuedDate": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 15,
                    "rule": "optional"
                  },
                  "provisionalCreditDebitedDate": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 16,
                    "rule": "optional"
                  },
                  "finalResolution": {
                    "type": ".squareup.bizbank.transaction_dispute.FinalResolution",
                    "id": 17,
                    "rule": "optional"
                  },
                  "resolutionReason": {
                    "type": ".squareup.bizbank.transaction_dispute.ResolutionReason",
                    "id": 18,
                    "rule": "optional"
                  },
                  "finalResolutionDate": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 19,
                    "rule": "optional"
                  },
                  "finalFollowUpDate": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 20,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 21,
                    "rule": "optional"
                  },
                  "updatedAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 22,
                    "rule": "optional"
                  },
                  "marqetaDisputeFiledByLdap": {
                    "type": "string",
                    "id": 23,
                    "rule": "optional"
                  },
                  "marqetaChargebackToken": {
                    "type": "string",
                    "id": 24,
                    "rule": "optional"
                  },
                  "publicStatus": {
                    "type": ".squareup.bizbank.transaction_dispute.PublicStatus",
                    "id": 25,
                    "rule": "optional"
                  }
                }
              },
              "ReasonCode": {
                "values": {
                  "UNKNOWN_REASON_CODE": 0,
                  "FRAUD_OR_UNAUTHORIZED": 1,
                  "NOT_RECEIVED": 2,
                  "NOT_DESCRIBED": 3,
                  "DUPLICATE_PROCESSING": 4,
                  "TRANSACTION_AMOUNT_INCORRECT": 5,
                  "CANCELED_OR_CREDIT_NOT_PROCESSED": 6
                }
              },
              "DisputeStatus": {
                "values": {
                  "UNKNOWN_DISPUTE_STATUS": 0,
                  "NEW": 1,
                  "WAITING_ON_CARD_HOLDER": 2,
                  "FILED": 3,
                  "INITIATED": 4,
                  "REPRESENTMENT": 5,
                  "PREARBITRATION": 6,
                  "ARBITRATION": 7,
                  "NETWORK_REJECTED": 8,
                  "WON": 9,
                  "LOST": 10,
                  "CLOSED": 11,
                  "PENDING_AUTOMATED_REVIEW": 12,
                  "PREARBITRATION_RESPONDED": 13
                }
              },
              "PublicStatus": {
                "values": {
                  "UNKNOWN_PUBLIC_STATUS": 0,
                  "PENDING_REVIEW": 1,
                  "INFORMATION_NEEDED": 2,
                  "IN_PROGRESS": 3,
                  "SELLER_WON": 4,
                  "SELLER_LOST": 5,
                  "RESOLVED": 6
                }
              },
              "FinalResolution": {
                "values": {
                  "UNKNOWN_FINAL_RESOLUTION": 0,
                  "APPROVED": 1,
                  "DENIED": 2,
                  "CREDITED_FROM_SQUARE": 3,
                  "VOIDED": 4,
                  "REJECTED_BY_SQUARE": 5,
                  "REFUNDED": 6,
                  "REJECTED_BY_MARQETA": 7,
                  "DENIED_WARNING": 8
                }
              },
              "ResolutionReason": {
                "values": {
                  "UNKNOWN_RESOLUTION_REASON": 0,
                  "ATO": 1,
                  "BUSINESS_DECISION": 2,
                  "CARDHOLDER_CANCELED_CLAIM": 3,
                  "DISPUTE_LOST": 4,
                  "DISPUTE_WON": 5,
                  "DENIAL_GUIDELINES": 6,
                  "LESS_THAN_25_DOLLARS": 7,
                  "NO_REPLY": 8,
                  "PAYMENT_WITH_CHIP_AND_PIN": 9,
                  "REFUND": 10,
                  "TRANSACTION_VOID": 11,
                  "MULTIPLE_TRANSACTIONS": 12,
                  "RESOLUTION_OVERTURNED": 13,
                  "INACCURATE_OR_INCOMPLETE": 14,
                  "AUTO_CHIP_OR_CONTACTLESS_WITH_CARD_IN_POSSESSION": 19,
                  "AUTO_CARD_PIN_USED": 20,
                  "AUTO_MOBILE_PAYMENT": 21,
                  "AUTO_CONSENT_PROVIDED": 22
                }
              },
              "DisputeForm": {
                "fields": {
                  "merchantName": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "transactionDate": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 2,
                    "rule": "optional"
                  },
                  "disputeAmount": {
                    "type": "int64",
                    "id": 3,
                    "rule": "optional"
                  },
                  "usedWithMerchantBefore": {
                    "type": ".squareup.bizbank.transaction_dispute.DisputeForm.DisputeFormAnswer",
                    "id": 4,
                    "rule": "optional"
                  },
                  "provideCardOrInformation": {
                    "type": ".squareup.bizbank.transaction_dispute.DisputeForm.DisputeFormAnswer",
                    "id": 5,
                    "rule": "optional"
                  },
                  "cardInPossession": {
                    "type": ".squareup.bizbank.transaction_dispute.DisputeForm.DisputeFormAnswer",
                    "id": 6,
                    "rule": "optional"
                  },
                  "firstDateCardMissing": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 7,
                    "rule": "optional"
                  },
                  "lastTransaction": {
                    "type": ".squareup.bizbank.transaction_dispute.DisputeForm.LastTransaction",
                    "id": 8,
                    "rule": "optional"
                  },
                  "sharedPinWithAnyone": {
                    "type": ".squareup.bizbank.transaction_dispute.DisputeForm.SharedPinWithAnyone",
                    "id": 9,
                    "rule": "optional"
                  },
                  "receivedExpectedProducts": {
                    "type": ".squareup.bizbank.transaction_dispute.DisputeForm.DisputeFormAnswer",
                    "id": 10,
                    "rule": "optional"
                  },
                  "didNotReceiveProductsDetails": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "receivedProductsOnAgreedDate": {
                    "type": ".squareup.bizbank.transaction_dispute.DisputeForm.DisputeFormAnswer",
                    "id": 12,
                    "rule": "optional"
                  },
                  "receivedExpectedProductsDate": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 13,
                    "rule": "optional"
                  },
                  "productsReceivedWereAsDescribed": {
                    "type": ".squareup.bizbank.transaction_dispute.DisputeForm.DisputeFormAnswer",
                    "id": 14,
                    "rule": "optional"
                  },
                  "productsReceivedWereNotAsDescribedDetails": {
                    "type": "string",
                    "id": 15,
                    "rule": "optional"
                  },
                  "chargedMultipleTimes": {
                    "type": ".squareup.bizbank.transaction_dispute.DisputeForm.DisputeFormAnswer",
                    "id": 16,
                    "rule": "optional"
                  },
                  "chargedMultipleTimesCorrectTransaction": {
                    "type": ".squareup.bizbank.transaction_dispute.DisputeForm.ChargedMultipleTimes",
                    "id": 17,
                    "rule": "optional"
                  },
                  "amountIsCorrect": {
                    "type": ".squareup.bizbank.transaction_dispute.DisputeForm.DisputeFormAnswer",
                    "id": 18,
                    "rule": "optional"
                  },
                  "correctChargeAmount": {
                    "type": "int64",
                    "id": 27,
                    "rule": "optional"
                  },
                  "purchaseWasCanceled": {
                    "type": ".squareup.bizbank.transaction_dispute.DisputeForm.DisputeFormAnswer",
                    "id": 19,
                    "rule": "optional"
                  },
                  "purchasedCanceledDate": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 20,
                    "rule": "optional"
                  },
                  "merchandiseIsReturned": {
                    "type": ".squareup.bizbank.transaction_dispute.DisputeForm.DisputeFormAnswer",
                    "id": 21,
                    "rule": "optional"
                  },
                  "returnedMerchandise": {
                    "type": ".squareup.bizbank.transaction_dispute.DisputeForm.ReturnedMerchandise",
                    "id": 22,
                    "rule": "optional"
                  },
                  "merchantAgreedToIssueCredit": {
                    "type": ".squareup.bizbank.transaction_dispute.DisputeForm.DisputeFormAnswer",
                    "id": 23,
                    "rule": "optional"
                  },
                  "merchantAgreedToIssueCreditDate": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 24,
                    "rule": "optional"
                  },
                  "anythingElse": {
                    "type": "string",
                    "id": 25,
                    "rule": "optional"
                  },
                  "pinWasWrittenDown": {
                    "type": ".squareup.bizbank.transaction_dispute.DisputeForm.DisputeFormAnswer",
                    "id": 26,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "DisputeFormAnswer": {
                    "values": {
                      "UNKNOWN_ANSWER": 0,
                      "NO": 1,
                      "YES": 2
                    }
                  },
                  "LastTransaction": {
                    "fields": {
                      "lastTransactionDate": {
                        "type": ".squareup.common.time.DateTime",
                        "id": 1,
                        "rule": "optional"
                      },
                      "lastTransactionMerchant": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "SharedPinWithAnyone": {
                    "fields": {
                      "hasSharedPinWithAnyone": {
                        "type": ".squareup.bizbank.transaction_dispute.DisputeForm.DisputeFormAnswer",
                        "id": 1,
                        "rule": "optional"
                      },
                      "sharedPinPerson": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "ChargedMultipleTimes": {
                    "fields": {
                      "correctChargeDate": {
                        "type": ".squareup.common.time.DateTime",
                        "id": 1,
                        "rule": "optional"
                      },
                      "correctChargeAmount": {
                        "type": "int64",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "ReturnedMerchandise": {
                    "fields": {
                      "returnedMerchandiseDate": {
                        "type": ".squareup.common.time.DateTime",
                        "id": 1,
                        "rule": "optional"
                      },
                      "returnedMerchandiseProof": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "GetTransactionDisputeRequest": {
                "fields": {
                  "transactionDisputeId": {
                    "type": "int64",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetTransactionDisputeResponse": {
                "fields": {
                  "transactionDispute": {
                    "type": ".squareup.bizbank.transaction_dispute.TransactionDispute",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetTransactionDisputeByTransactionTokenRequest": {
                "fields": {
                  "transactionToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetTransactionDisputeByTransactionTokenResponse": {
                "fields": {
                  "transactionDispute": {
                    "type": ".squareup.bizbank.transaction_dispute.TransactionDispute",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetTransactionDisputeActivityRequest": {
                "fields": {
                  "transactionDisputeId": {
                    "type": "int64",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetTransactionDisputeActivityResponse": {
                "fields": {
                  "events": {
                    "type": ".squareup.bizbank.transaction_dispute.Event",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "Event": {
                "fields": {
                  "eventAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 1,
                    "rule": "optional"
                  },
                  "statusChangeEvent": {
                    "type": ".squareup.bizbank.transaction_dispute.Event.StatusChangeEvent",
                    "id": 2
                  },
                  "futureStatusChangeEvent": {
                    "type": ".squareup.bizbank.transaction_dispute.Event.FutureStatusChangeEvent",
                    "id": 3
                  },
                  "creditIssuedEvent": {
                    "type": ".squareup.bizbank.transaction_dispute.Event.CreditIssuedEvent",
                    "id": 4
                  },
                  "creditDebitedEvent": {
                    "type": ".squareup.bizbank.transaction_dispute.Event.CreditDebitedEvent",
                    "id": 5
                  }
                },
                "nested": {
                  "StatusChangeEvent": {
                    "fields": {
                      "publicStatus": {
                        "type": ".squareup.bizbank.transaction_dispute.PublicStatus",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "FutureStatusChangeEvent": {
                    "fields": {
                      "publicStatus": {
                        "type": ".squareup.bizbank.transaction_dispute.PublicStatus",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "CreditIssuedEvent": {
                    "fields": {
                      "amount": {
                        "type": ".squareup.common.Money",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "CreditDebitedEvent": {
                    "fields": {
                      "amount": {
                        "type": ".squareup.common.Money",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "event": {
                    "oneof": [
                      "statusChangeEvent",
                      "futureStatusChangeEvent",
                      "creditIssuedEvent",
                      "creditDebitedEvent"
                    ]
                  }
                }
              },
              "ListTransactionDisputesRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "beginTime": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 2,
                    "rule": "optional"
                  },
                  "endTime": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 3,
                    "rule": "optional"
                  },
                  "includeStatuses": {
                    "type": ".squareup.bizbank.transaction_dispute.DisputeStatus",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "inProgressOnly": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional"
                  },
                  "batchRequest": {
                    "type": ".squareup.bizbank.model.BatchRequest",
                    "id": 6,
                    "rule": "optional"
                  },
                  "resolvedOnly": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional"
                  },
                  "transactionToken": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  }
                }
              },
              "ListTransactionDisputesResponse": {
                "fields": {
                  "transactionDisputes": {
                    "type": ".squareup.bizbank.transaction_dispute.TransactionDispute",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "paginationToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ListTransactionDisputeStatusUpdatesRequest": {
                "fields": {
                  "transactionDisputeId": {
                    "type": "int64",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ListTransactionDisputeStatusUpdatesResponse": {
                "fields": {
                  "statusUpdates": {
                    "type": ".squareup.bizbank.transaction_dispute.ListTransactionDisputeStatusUpdatesResponse.StatusUpdate",
                    "id": 1,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "StatusUpdate": {
                    "fields": {
                      "transactionDisputesHistoryId": {
                        "type": "int64",
                        "id": 1,
                        "rule": "optional"
                      },
                      "status": {
                        "type": ".squareup.bizbank.transaction_dispute.DisputeStatus",
                        "id": 2,
                        "rule": "optional"
                      },
                      "statusUpdatedDate": {
                        "type": ".squareup.common.time.DateTime",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "CreateTransactionDisputeRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "disputeAmount": {
                    "type": ".squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "disputeForm": {
                    "type": ".squareup.bizbank.transaction_dispute.DisputeForm",
                    "id": 3,
                    "rule": "optional"
                  },
                  "reasonCode": {
                    "type": ".squareup.bizbank.transaction_dispute.ReasonCode",
                    "id": 4,
                    "rule": "optional"
                  },
                  "sellerDisputedDate": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 5,
                    "rule": "optional"
                  },
                  "outreachUrl": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "transactionToken": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  }
                }
              },
              "CreateTransactionDisputeResponse": {
                "fields": {
                  "success": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "transactionDisputeId": {
                    "type": "int64",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "UpdateTransactionDisputeRequest": {
                "fields": {
                  "transactionDisputeId": {
                    "type": "int64",
                    "id": 1,
                    "rule": "optional"
                  },
                  "status": {
                    "type": ".squareup.bizbank.transaction_dispute.DisputeStatus",
                    "id": 2,
                    "rule": "optional"
                  },
                  "statusUpdatedAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 3,
                    "rule": "optional"
                  },
                  "outreachUrl": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "transactionToken": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "squareDisputedDate": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 6,
                    "rule": "optional"
                  },
                  "provisionalCreditAmount": {
                    "type": ".squareup.common.Money",
                    "id": 7,
                    "rule": "optional"
                  },
                  "provisionalCreditIssuedDate": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 8,
                    "rule": "optional"
                  },
                  "provisionalCreditDebitedDate": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 9,
                    "rule": "optional"
                  },
                  "finalResolution": {
                    "type": ".squareup.bizbank.transaction_dispute.FinalResolution",
                    "id": 10,
                    "rule": "optional"
                  },
                  "resolutionReason": {
                    "type": ".squareup.bizbank.transaction_dispute.ResolutionReason",
                    "id": 11,
                    "rule": "optional"
                  },
                  "finalResolutionDate": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 12,
                    "rule": "optional"
                  },
                  "finalFollowUpDate": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 13,
                    "rule": "optional"
                  },
                  "reasonCode": {
                    "type": ".squareup.bizbank.transaction_dispute.ReasonCode",
                    "id": 14,
                    "rule": "optional"
                  },
                  "marqetaDisputeFiledByLdap": {
                    "type": "string",
                    "id": 15,
                    "rule": "optional"
                  },
                  "marqetaChargebackToken": {
                    "type": "string",
                    "id": 16,
                    "rule": "optional"
                  },
                  "disputeAmount": {
                    "type": ".squareup.common.Money",
                    "id": 17,
                    "rule": "optional"
                  },
                  "marqetaCaseToken": {
                    "type": "string",
                    "id": 18,
                    "rule": "optional"
                  }
                }
              },
              "UpdateTransactionDisputeByTransactionTokenRequest": {
                "fields": {
                  "transactionToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "status": {
                    "type": ".squareup.bizbank.transaction_dispute.DisputeStatus",
                    "id": 2,
                    "rule": "optional"
                  },
                  "statusUpdatedAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 3,
                    "rule": "optional"
                  },
                  "outreachUrl": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "squareDisputedDate": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 5,
                    "rule": "optional"
                  },
                  "provisionalCreditAmount": {
                    "type": ".squareup.common.Money",
                    "id": 6,
                    "rule": "optional"
                  },
                  "provisionalCreditIssuedDate": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 7,
                    "rule": "optional"
                  },
                  "provisionalCreditDebitedDate": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 8,
                    "rule": "optional"
                  },
                  "finalResolution": {
                    "type": ".squareup.bizbank.transaction_dispute.FinalResolution",
                    "id": 9,
                    "rule": "optional"
                  },
                  "resolutionReason": {
                    "type": ".squareup.bizbank.transaction_dispute.ResolutionReason",
                    "id": 10,
                    "rule": "optional"
                  },
                  "finalResolutionDate": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 11,
                    "rule": "optional"
                  },
                  "finalFollowUpDate": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 12,
                    "rule": "optional"
                  },
                  "reasonCode": {
                    "type": ".squareup.bizbank.transaction_dispute.ReasonCode",
                    "id": 13,
                    "rule": "optional"
                  },
                  "marqetaDisputeFiledByLdap": {
                    "type": "string",
                    "id": 14,
                    "rule": "optional"
                  },
                  "marqetaChargebackToken": {
                    "type": "string",
                    "id": 15,
                    "rule": "optional"
                  },
                  "disputeAmount": {
                    "type": ".squareup.common.Money",
                    "id": 16,
                    "rule": "optional"
                  },
                  "marqetaCaseToken": {
                    "type": "string",
                    "id": 17,
                    "rule": "optional"
                  }
                }
              },
              "UpdateTransactionDisputeResponse": {
                "fields": {
                  "success": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "HandleDisputeStatusUpdateEventRequest": {
                "fields": {
                  "updateEventJson": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "HandleDisputeStatusUpdateEventResponse": {
                "fields": {}
              },
              "MarqetaDisputeReason": {
                "values": {
                  "UNKNOWN_MQ_DISPUTE_REASON": 0,
                  "WARNING_BULLETIN_FILE": 1,
                  "AUTHORIZATION_RELATED_FOR_DUAL_MESSAGE_SYSTEM": 2,
                  "ACCOUNT_NUMBER_NOT_ON_FILE": 3,
                  "INCORRECT_TRANSACTION_AMOUNT_OR_ACCOUNT_NUMBER": 4,
                  "POINT_OF_INTERACTION_ERRORS": 5,
                  "NOT_AUTHORIZED_CARD_PRESENT": 6,
                  "NOT_AUTHORIZED_CARD_ABSENT": 7,
                  "FRAUD_TRANSACTION": 8,
                  "CANCELLED_RECURRING_TRANSACTION": 9,
                  "LATE_PRESENTMENT": 10,
                  "INCORRECT_CURRENCY": 11,
                  "INCORRECT_TRANSACTION_CODE": 12,
                  "INCORRECT_CURRENCY_OR_TRANSACTION_CODE": 13,
                  "QUESTIONABLE_MERCHANT_ACTIVITY": 14,
                  "INSTALLMENT_BILLING_DISPUTE": 15,
                  "CARDHOLDER_DISPUTE_US_ONLY": 16,
                  "SERVICE_NOT_PROVIDED_MERCHANDISE_NOT_RECEIVED": 17,
                  "NO_SHOW_ADDENDUM_OR_ATM_DISPUTE": 18,
                  "CREDIT_NOT_PROCESSED": 19,
                  "TRANSACTION_NOT_RECOGNIZED": 20,
                  "CHIP_LIABILITY_SHIFT": 21,
                  "CHIP_PIN_LIABILITY_SHIFT_LOST_STOLEN": 22,
                  "CHIP_READ_POS_LATE_PRESENTMENT": 23,
                  "DOMESTIC_CHARGEBACK_INTRA_EUROPEAN_USE": 24,
                  "CARDHOLDER_DISPUTE": 25
                }
              },
              "MarqetaDisputeDocumentCategory": {
                "values": {
                  "UNKNOWN_MQ_DISPUTE_DOCUMENT_CATEGORY": 0,
                  "RECEIPT": 1,
                  "CUSTOMER_SIGNATURE": 2,
                  "CUSTOMER_DL": 3,
                  "CUSTOMER_SSN": 4,
                  "CUSTOMER_PASSPORT": 5,
                  "UTILITY_BILL": 6,
                  "CUSTOMER_COMMUNICATION": 7,
                  "DISPUTE_FORM": 8,
                  "BANK_STATEMENT": 9,
                  "TAX_DOCUMENTS": 10,
                  "INCORPORATION_CERTIFICATE": 11,
                  "LEASE_AGREEMENT": 12,
                  "OTHERS": 13
                }
              },
              "CreateMarqetaDisputeRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "disputeAmount": {
                    "type": ".squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "transactionToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "marqetaDisputeReason": {
                    "type": ".squareup.bizbank.transaction_dispute.MarqetaDisputeReason",
                    "id": 4,
                    "rule": "optional"
                  },
                  "submittedBy": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "memo": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "document": {
                    "type": ".squareup.bizbank.transaction_dispute.CreateMarqetaDisputeRequest.Document",
                    "id": 7,
                    "rule": "optional"
                  },
                  "transactionDisputeId": {
                    "type": "int64",
                    "id": 8,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Document": {
                    "fields": {
                      "fileBytes": {
                        "type": "bytes",
                        "id": 1,
                        "rule": "optional"
                      },
                      "contentType": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "fileName": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "category": {
                        "type": ".squareup.bizbank.transaction_dispute.MarqetaDisputeDocumentCategory",
                        "id": 4,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "CreateMarqetaDisputeResponse": {
                "fields": {
                  "success": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errorMessage": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "LedgerDisputeLostRequest": {
                "fields": {
                  "transactionDisputeId": {
                    "type": "int64",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "LedgerDisputeLostResponse": {
                "fields": {}
              }
            }
          }
        }
      }
    }
  }
}

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.TransactionDispute && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.ReasonCode && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.DisputeStatus && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.PublicStatus && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.FinalResolution && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.ResolutionReason && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.DisputeForm && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.DisputeForm?.nested?.DisputeFormAnswer && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.DisputeForm?.nested?.LastTransaction && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.DisputeForm?.nested?.SharedPinWithAnyone && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.DisputeForm?.nested?.ChargedMultipleTimes && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.DisputeForm?.nested?.ReturnedMerchandise && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.GetTransactionDisputeRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.GetTransactionDisputeResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.GetTransactionDisputeByTransactionTokenRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.GetTransactionDisputeByTransactionTokenResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.GetTransactionDisputeActivityRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.GetTransactionDisputeActivityResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.Event && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.Event?.nested?.StatusChangeEvent && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.Event?.nested?.FutureStatusChangeEvent && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.Event?.nested?.CreditIssuedEvent && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.Event?.nested?.CreditDebitedEvent && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.ListTransactionDisputesRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.ListTransactionDisputesResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.ListTransactionDisputeStatusUpdatesRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.ListTransactionDisputeStatusUpdatesResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.ListTransactionDisputeStatusUpdatesResponse?.nested?.StatusUpdate && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.CreateTransactionDisputeRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.CreateTransactionDisputeResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.UpdateTransactionDisputeRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.UpdateTransactionDisputeByTransactionTokenRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.UpdateTransactionDisputeResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.HandleDisputeStatusUpdateEventRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.HandleDisputeStatusUpdateEventResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.MarqetaDisputeReason && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.MarqetaDisputeDocumentCategory && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.CreateMarqetaDisputeRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.CreateMarqetaDisputeRequest?.nested?.Document && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.CreateMarqetaDisputeResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.LedgerDisputeLostRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.LedgerDisputeLostResponse) {
	$root.addJSON(jsonData);
}

/**
 * SOURCE TransactionDispute @ squareup/bizbank/transaction_dispute.proto at 15:1
 */
export const TransactionDispute = $root.lookupType('squareup.bizbank.transaction_dispute.TransactionDispute');
fixType(TransactionDispute);
Builder.createAndAttachToType(TransactionDispute);
/**
 * SOURCE ReasonCode @ squareup/bizbank/transaction_dispute.proto at 98:1
 */
export const ReasonCode = $root.lookupEnum('squareup.bizbank.transaction_dispute.ReasonCode').values;
/**
 * SOURCE DisputeStatus @ squareup/bizbank/transaction_dispute.proto at 108:1
 */
export const DisputeStatus = $root.lookupEnum('squareup.bizbank.transaction_dispute.DisputeStatus').values;
/**
 * SOURCE PublicStatus @ squareup/bizbank/transaction_dispute.proto at 125:1
 */
export const PublicStatus = $root.lookupEnum('squareup.bizbank.transaction_dispute.PublicStatus').values;
/**
 * SOURCE FinalResolution @ squareup/bizbank/transaction_dispute.proto at 135:1
 */
export const FinalResolution = $root.lookupEnum('squareup.bizbank.transaction_dispute.FinalResolution').values;
/**
 * SOURCE ResolutionReason @ squareup/bizbank/transaction_dispute.proto at 149:1
 */
export const ResolutionReason = $root.lookupEnum('squareup.bizbank.transaction_dispute.ResolutionReason').values;
/**
 * SOURCE DisputeForm @ squareup/bizbank/transaction_dispute.proto at 176:1
 */
export const DisputeForm = $root.lookupType('squareup.bizbank.transaction_dispute.DisputeForm');
fixType(DisputeForm);
Builder.createAndAttachToType(DisputeForm);
/**
 * SOURCE DisputeFormAnswer @ squareup/bizbank/transaction_dispute.proto at 177:3
 */
DisputeForm.DisputeFormAnswer = $root.lookupEnum('squareup.bizbank.transaction_dispute.DisputeForm.DisputeFormAnswer').values;
/**
 * What was the last transaction you made with your Square Card?
 *
 * SOURCE LastTransaction @ squareup/bizbank/transaction_dispute.proto at 205:3
 */
DisputeForm.LastTransaction = $root.lookupType('squareup.bizbank.transaction_dispute.DisputeForm.LastTransaction');
fixType(DisputeForm.LastTransaction);
Builder.createAndAttachToType(DisputeForm.LastTransaction);
/**
 * SOURCE SharedPinWithAnyone @ squareup/bizbank/transaction_dispute.proto at 212:3
 */
DisputeForm.SharedPinWithAnyone = $root.lookupType('squareup.bizbank.transaction_dispute.DisputeForm.SharedPinWithAnyone');
fixType(DisputeForm.SharedPinWithAnyone);
Builder.createAndAttachToType(DisputeForm.SharedPinWithAnyone);
/**
 * If you were charged multiple times for this payment, what was the date and amount of the correct transaction?
 *
 * SOURCE ChargedMultipleTimes @ squareup/bizbank/transaction_dispute.proto at 243:3
 */
DisputeForm.ChargedMultipleTimes = $root.lookupType('squareup.bizbank.transaction_dispute.DisputeForm.ChargedMultipleTimes');
fixType(DisputeForm.ChargedMultipleTimes);
Builder.createAndAttachToType(DisputeForm.ChargedMultipleTimes);
/**
 * If you’ve returned the merchandise, please provide the return date and provide proof of return authorization (i.e tracking number, delivery confirmation, or return merchandise authorization)
 *
 * SOURCE ReturnedMerchandise @ squareup/bizbank/transaction_dispute.proto at 265:3
 */
DisputeForm.ReturnedMerchandise = $root.lookupType('squareup.bizbank.transaction_dispute.DisputeForm.ReturnedMerchandise');
fixType(DisputeForm.ReturnedMerchandise);
Builder.createAndAttachToType(DisputeForm.ReturnedMerchandise);
/**
 * SOURCE GetTransactionDisputeRequest @ squareup/bizbank/transaction_dispute.proto at 285:1
 */
export const GetTransactionDisputeRequest = $root.lookupType('squareup.bizbank.transaction_dispute.GetTransactionDisputeRequest');
fixType(GetTransactionDisputeRequest, {
  transactionDisputeId: { required: true },
});
Builder.createAndAttachToType(GetTransactionDisputeRequest);
/**
 * SOURCE GetTransactionDisputeResponse @ squareup/bizbank/transaction_dispute.proto at 289:1
 */
export const GetTransactionDisputeResponse = $root.lookupType('squareup.bizbank.transaction_dispute.GetTransactionDisputeResponse');
fixType(GetTransactionDisputeResponse);
Builder.createAndAttachToType(GetTransactionDisputeResponse);
/**
 * SOURCE GetTransactionDisputeByTransactionTokenRequest @ squareup/bizbank/transaction_dispute.proto at 293:1
 */
export const GetTransactionDisputeByTransactionTokenRequest = $root.lookupType('squareup.bizbank.transaction_dispute.GetTransactionDisputeByTransactionTokenRequest');
fixType(GetTransactionDisputeByTransactionTokenRequest, {
  transactionToken: { notEmpty: true },
});
Builder.createAndAttachToType(GetTransactionDisputeByTransactionTokenRequest);
/**
 * SOURCE GetTransactionDisputeByTransactionTokenResponse @ squareup/bizbank/transaction_dispute.proto at 297:1
 */
export const GetTransactionDisputeByTransactionTokenResponse = $root.lookupType('squareup.bizbank.transaction_dispute.GetTransactionDisputeByTransactionTokenResponse');
fixType(GetTransactionDisputeByTransactionTokenResponse);
Builder.createAndAttachToType(GetTransactionDisputeByTransactionTokenResponse);
/**
 * SOURCE GetTransactionDisputeActivityRequest @ squareup/bizbank/transaction_dispute.proto at 301:1
 */
export const GetTransactionDisputeActivityRequest = $root.lookupType('squareup.bizbank.transaction_dispute.GetTransactionDisputeActivityRequest');
fixType(GetTransactionDisputeActivityRequest, {
  transactionDisputeId: { required: true },
});
Builder.createAndAttachToType(GetTransactionDisputeActivityRequest);
/**
 * SOURCE GetTransactionDisputeActivityResponse @ squareup/bizbank/transaction_dispute.proto at 305:1
 */
export const GetTransactionDisputeActivityResponse = $root.lookupType('squareup.bizbank.transaction_dispute.GetTransactionDisputeActivityResponse');
fixType(GetTransactionDisputeActivityResponse);
Builder.createAndAttachToType(GetTransactionDisputeActivityResponse);
/**
 * SOURCE Event @ squareup/bizbank/transaction_dispute.proto at 309:1
 */
export const Event = $root.lookupType('squareup.bizbank.transaction_dispute.Event');
fixType(Event);
Builder.createAndAttachToType(Event);
/**
 * SOURCE StatusChangeEvent @ squareup/bizbank/transaction_dispute.proto at 319:3
 */
Event.StatusChangeEvent = $root.lookupType('squareup.bizbank.transaction_dispute.Event.StatusChangeEvent');
fixType(Event.StatusChangeEvent);
Builder.createAndAttachToType(Event.StatusChangeEvent);
/**
 * SOURCE FutureStatusChangeEvent @ squareup/bizbank/transaction_dispute.proto at 323:3
 */
Event.FutureStatusChangeEvent = $root.lookupType('squareup.bizbank.transaction_dispute.Event.FutureStatusChangeEvent');
fixType(Event.FutureStatusChangeEvent);
Builder.createAndAttachToType(Event.FutureStatusChangeEvent);
/**
 * SOURCE CreditIssuedEvent @ squareup/bizbank/transaction_dispute.proto at 327:3
 */
Event.CreditIssuedEvent = $root.lookupType('squareup.bizbank.transaction_dispute.Event.CreditIssuedEvent');
fixType(Event.CreditIssuedEvent);
Builder.createAndAttachToType(Event.CreditIssuedEvent);
/**
 * SOURCE CreditDebitedEvent @ squareup/bizbank/transaction_dispute.proto at 331:3
 */
Event.CreditDebitedEvent = $root.lookupType('squareup.bizbank.transaction_dispute.Event.CreditDebitedEvent');
fixType(Event.CreditDebitedEvent);
Builder.createAndAttachToType(Event.CreditDebitedEvent);
/**
 * SOURCE ListTransactionDisputesRequest @ squareup/bizbank/transaction_dispute.proto at 336:1
 */
export const ListTransactionDisputesRequest = $root.lookupType('squareup.bizbank.transaction_dispute.ListTransactionDisputesRequest');
fixType(ListTransactionDisputesRequest, {
  unitToken: { notEmpty: true },
});
Builder.createAndAttachToType(ListTransactionDisputesRequest);
/**
 * SOURCE ListTransactionDisputesResponse @ squareup/bizbank/transaction_dispute.proto at 347:1
 */
export const ListTransactionDisputesResponse = $root.lookupType('squareup.bizbank.transaction_dispute.ListTransactionDisputesResponse');
fixType(ListTransactionDisputesResponse);
Builder.createAndAttachToType(ListTransactionDisputesResponse);
/**
 * SOURCE ListTransactionDisputeStatusUpdatesRequest @ squareup/bizbank/transaction_dispute.proto at 352:1
 */
export const ListTransactionDisputeStatusUpdatesRequest = $root.lookupType('squareup.bizbank.transaction_dispute.ListTransactionDisputeStatusUpdatesRequest');
fixType(ListTransactionDisputeStatusUpdatesRequest, {
  transactionDisputeId: { required: true },
});
Builder.createAndAttachToType(ListTransactionDisputeStatusUpdatesRequest);
/**
 * SOURCE ListTransactionDisputeStatusUpdatesResponse @ squareup/bizbank/transaction_dispute.proto at 356:1
 */
export const ListTransactionDisputeStatusUpdatesResponse = $root.lookupType('squareup.bizbank.transaction_dispute.ListTransactionDisputeStatusUpdatesResponse');
fixType(ListTransactionDisputeStatusUpdatesResponse);
Builder.createAndAttachToType(ListTransactionDisputeStatusUpdatesResponse);
/**
 * SOURCE StatusUpdate @ squareup/bizbank/transaction_dispute.proto at 359:3
 */
ListTransactionDisputeStatusUpdatesResponse.StatusUpdate = $root.lookupType('squareup.bizbank.transaction_dispute.ListTransactionDisputeStatusUpdatesResponse.StatusUpdate');
fixType(ListTransactionDisputeStatusUpdatesResponse.StatusUpdate);
Builder.createAndAttachToType(ListTransactionDisputeStatusUpdatesResponse.StatusUpdate);
/**
 * SOURCE CreateTransactionDisputeRequest @ squareup/bizbank/transaction_dispute.proto at 366:1
 */
export const CreateTransactionDisputeRequest = $root.lookupType('squareup.bizbank.transaction_dispute.CreateTransactionDisputeRequest');
fixType(CreateTransactionDisputeRequest, {
  unitToken: { notEmpty: true },
  disputeAmount: { required: true },
  reasonCode: { required: true },
  sellerDisputedDate: { required: true },
});
Builder.createAndAttachToType(CreateTransactionDisputeRequest);
/**
 * SOURCE CreateTransactionDisputeResponse @ squareup/bizbank/transaction_dispute.proto at 376:1
 */
export const CreateTransactionDisputeResponse = $root.lookupType('squareup.bizbank.transaction_dispute.CreateTransactionDisputeResponse');
fixType(CreateTransactionDisputeResponse);
Builder.createAndAttachToType(CreateTransactionDisputeResponse);
/**
 * SOURCE UpdateTransactionDisputeRequest @ squareup/bizbank/transaction_dispute.proto at 381:1
 */
export const UpdateTransactionDisputeRequest = $root.lookupType('squareup.bizbank.transaction_dispute.UpdateTransactionDisputeRequest');
fixType(UpdateTransactionDisputeRequest, {
  transactionDisputeId: { required: true },
});
Builder.createAndAttachToType(UpdateTransactionDisputeRequest);
/**
 * SOURCE UpdateTransactionDisputeByTransactionTokenRequest @ squareup/bizbank/transaction_dispute.proto at 402:1
 */
export const UpdateTransactionDisputeByTransactionTokenRequest = $root.lookupType('squareup.bizbank.transaction_dispute.UpdateTransactionDisputeByTransactionTokenRequest');
fixType(UpdateTransactionDisputeByTransactionTokenRequest, {
  transactionToken: { notEmpty: true },
});
Builder.createAndAttachToType(UpdateTransactionDisputeByTransactionTokenRequest);
/**
 * SOURCE UpdateTransactionDisputeResponse @ squareup/bizbank/transaction_dispute.proto at 422:1
 */
export const UpdateTransactionDisputeResponse = $root.lookupType('squareup.bizbank.transaction_dispute.UpdateTransactionDisputeResponse');
fixType(UpdateTransactionDisputeResponse);
Builder.createAndAttachToType(UpdateTransactionDisputeResponse);
/**
 * SOURCE HandleDisputeStatusUpdateEventRequest @ squareup/bizbank/transaction_dispute.proto at 426:1
 */
export const HandleDisputeStatusUpdateEventRequest = $root.lookupType('squareup.bizbank.transaction_dispute.HandleDisputeStatusUpdateEventRequest');
fixType(HandleDisputeStatusUpdateEventRequest, {
  updateEventJson: { notEmpty: true },
});
Builder.createAndAttachToType(HandleDisputeStatusUpdateEventRequest);
/**
 * SOURCE HandleDisputeStatusUpdateEventResponse @ squareup/bizbank/transaction_dispute.proto at 430:1
 */
export const HandleDisputeStatusUpdateEventResponse = $root.lookupType('squareup.bizbank.transaction_dispute.HandleDisputeStatusUpdateEventResponse');
fixType(HandleDisputeStatusUpdateEventResponse);
Builder.createAndAttachToType(HandleDisputeStatusUpdateEventResponse);
/**
 * SOURCE MarqetaDisputeReason @ squareup/bizbank/transaction_dispute.proto at 432:1
 */
export const MarqetaDisputeReason = $root.lookupEnum('squareup.bizbank.transaction_dispute.MarqetaDisputeReason').values;
/**
 * SOURCE MarqetaDisputeDocumentCategory @ squareup/bizbank/transaction_dispute.proto at 461:1
 */
export const MarqetaDisputeDocumentCategory = $root.lookupEnum('squareup.bizbank.transaction_dispute.MarqetaDisputeDocumentCategory').values;
/**
 * SOURCE CreateMarqetaDisputeRequest @ squareup/bizbank/transaction_dispute.proto at 478:1
 */
export const CreateMarqetaDisputeRequest = $root.lookupType('squareup.bizbank.transaction_dispute.CreateMarqetaDisputeRequest');
fixType(CreateMarqetaDisputeRequest, {
  unitToken: { notEmpty: true },
  disputeAmount: { required: true },
  transactionToken: { notEmpty: true },
  marqetaDisputeReason: { required: true },
  submittedBy: { notEmpty: true },
});
Builder.createAndAttachToType(CreateMarqetaDisputeRequest);
/**
 * SOURCE Document @ squareup/bizbank/transaction_dispute.proto at 488:3
 */
CreateMarqetaDisputeRequest.Document = $root.lookupType('squareup.bizbank.transaction_dispute.CreateMarqetaDisputeRequest.Document');
fixType(CreateMarqetaDisputeRequest.Document, {
  contentType: { notEmpty: true },
  fileName: { notEmpty: true },
  category: { required: true },
});
Builder.createAndAttachToType(CreateMarqetaDisputeRequest.Document);
/**
 * SOURCE CreateMarqetaDisputeResponse @ squareup/bizbank/transaction_dispute.proto at 496:1
 */
export const CreateMarqetaDisputeResponse = $root.lookupType('squareup.bizbank.transaction_dispute.CreateMarqetaDisputeResponse');
fixType(CreateMarqetaDisputeResponse, {
  success: { required: true },
});
Builder.createAndAttachToType(CreateMarqetaDisputeResponse);
/**
 * SOURCE LedgerDisputeLostRequest @ squareup/bizbank/transaction_dispute.proto at 501:1
 */
export const LedgerDisputeLostRequest = $root.lookupType('squareup.bizbank.transaction_dispute.LedgerDisputeLostRequest');
fixType(LedgerDisputeLostRequest, {
  transactionDisputeId: { required: true },
});
Builder.createAndAttachToType(LedgerDisputeLostRequest);
/**
 * SOURCE LedgerDisputeLostResponse @ squareup/bizbank/transaction_dispute.proto at 505:1
 */
export const LedgerDisputeLostResponse = $root.lookupType('squareup.bizbank.transaction_dispute.LedgerDisputeLostResponse');
fixType(LedgerDisputeLostResponse);
Builder.createAndAttachToType(LedgerDisputeLostResponse);
